<template>
  <div v-if="isNotObject" class="flex items-center key-value-item">
    <div
      class="key-value-fields flex flex-grow border-b border-zinc-200 dark:border-zinc-700"
    >
      <div
        class="w-48 flex-none cursor-text"
        :class="[
          readOnlyKeys || !isEditable
            ? 'bg-zinc-50 dark:bg-zinc-900'
            : 'bg-white dark:bg-zinc-900',
        ]"
      >
        <textarea
          rows="1"
          :dusk="`key-value-key-${index}`"
          v-model="item.key"
          @focus="handleKeyFieldFocus"
          ref="keyField"
          type="text"
          class="block w-full resize-none bg-clip-border px-3 py-3 text-xs focus:outline-none focus:ring focus:ring-inset dark:text-zinc-300"
          :readonly="!isEditable || readOnlyKeys"
          :tabindex="!isEditable || readOnlyKeys ? -1 : 0"
          :class="{
            'cursor-not-allowed bg-zinc-50 focus:outline-none dark:bg-zinc-900':
              !isEditable || readOnlyKeys,
            'bg-white hover:bg-zinc-50 focus:bg-white dark:bg-zinc-900 dark:hover:bg-zinc-800 dark:focus:bg-zinc-900':
              isEditable && !readOnlyKeys,
          }"
        />
      </div>

      <div
        class="flex-grow border-s border-zinc-200 dark:border-zinc-700"
        :class="[
          readOnlyKeys || !isEditable
            ? 'bg-zinc-50 dark:bg-zinc-900'
            : 'bg-white dark:bg-zinc-900',
        ]"
        @click="handleValueFieldFocus"
      >
        <textarea
          rows="1"
          :dusk="`key-value-value-${index}`"
          v-model="item.value"
          @focus="handleValueFieldFocus"
          ref="valueField"
          type="text"
          class="block w-full px-3 py-3 text-xs dark:text-zinc-300"
          :readonly="!isEditable"
          :tabindex="!isEditable ? -1 : 0"
          :class="{
            'cursor-not-allowed bg-zinc-50 focus:outline-none dark:bg-zinc-900': !isEditable,
            'bg-white hover:bg-zinc-50 focus:bg-white focus:outline-none focus:ring focus:ring-inset dark:bg-zinc-900 dark:hover:bg-zinc-800 dark:focus:bg-zinc-900':
              isEditable,
          }"
        />
      </div>
    </div>

    <div
      v-if="isEditable && canDeleteRow"
      class="flex justify-center h-11 w-11 absolute -right-[50px]"
    >
      <Button
        @click="$emit('remove-row', item.id)"
        :dusk="`remove-key-value-${index}`"
        variant="link"
        state="danger"
        type="button"
        tabindex="0"
        :title="__('Delete')"
        icon="minus-circle"
      />
    </div>
  </div>
</template>

<script>
import autosize from 'autosize'
import { Button } from 'laravel-nova-ui'

export default {
  components: {
    Button,
  },

  emits: ['remove-row'],

  props: {
    index: Number,
    item: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    readOnlyKeys: {
      type: Boolean,
      default: false,
    },
    canDeleteRow: {
      type: Boolean,
      default: true,
    },
  },

  mounted() {
    autosize(this.$refs.keyField)
    autosize(this.$refs.valueField)
  },

  methods: {
    handleKeyFieldFocus() {
      this.$refs.keyField.select()
    },

    handleValueFieldFocus() {
      this.$refs.valueField.select()
    },
  },

  computed: {
    isNotObject() {
      return !(this.item.value instanceof Object)
    },
    isEditable() {
      return !this.readOnly && !this.disabled
    },
  },
}
</script>
